import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-caption" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
      inactive: "text-gray-dark",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const Caption = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <div data-testid={testId} className={base({ className })}>
      {children}
    </div>
  );
};

export default Caption;
